import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@fontsource/opendyslexic/400.css";
import "@fontsource/opendyslexic/700.css";
import "./index.css";
import "./lib/i18n";
import { clearStaleAuthTokenCookie } from "./lib/auth-bootstrap";
import { exposeClearLanguageForDev, exposeSimplifiedTextCacheCommand } from "./lib/clear-language-for-testing";
import { installChunkLoadRecovery } from "./lib/chunk-load-recovery";

clearStaleAuthTokenCookie();
exposeClearLanguageForDev();
exposeSimplifiedTextCacheCommand();
installChunkLoadRecovery();

// Accessibilité : axe-core tourne uniquement en mode dev (logs DOM dans la console).
// `__LYRRA_DEV__` est défini dans vite.config.ts → esbuild remplace puis DCE en prod.
declare const __LYRRA_DEV__: boolean;
if (__LYRRA_DEV__) {
  void import("./lib/dev/axe-bootstrap").then(({ startAxe }) => startAxe(React, ReactDOM));
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
